export const FORM_ID = 'experience-workspace';
export const METADATA_FORM_ID = 'experience-metadata';
